module.exports = __webpack_public_path__ + "static/media/br.f82acc4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/languages/br.svg
// module id = 1859
// module chunks = 0